export default function AbilityPointsRadarChart({ data = [] }) {

    const numberOfAbilityPoints = data.length || 1;

    const getMax = () => {
        return 5
    }
    return (
        <div className="w-full flex justify-center items-center" style={{ height: undefined, aspectRatio: 1, objectFit: 'contain' }}>
            <svg width={'95%'} height={'95%'} viewBox="0 0 1000 1000">
                <polygon
                    points={
                        Array.from({ length: numberOfAbilityPoints }, (_, i) => {
                            const angle = (2 * Math.PI * i) / numberOfAbilityPoints;
                            const x = 500 + 400 * Math.cos(angle);
                            const y = 500 + 400 * Math.sin(angle);
                            return `${x},${y}`;
                        }).join(" ")
                    }
                    fill="none"
                    stroke="#1F4CC8"
                    strokeWidth="3"
                />
                {Array.from({ length: numberOfAbilityPoints }, (_, i) => {
                    const angle = (2 * Math.PI * i) / numberOfAbilityPoints;
                    const x = 500 + 400 * Math.cos(angle);
                    const y = 500 + 400 * Math.sin(angle);
                    return (
                        <line
                            key={i}
                            x1="500"
                            y1="500"
                            x2={x}
                            y2={y}
                            stroke="#1F4CC8"
                            strokeWidth="1"
                        />
                    );
                })}
                {Array.from({ length: getMax() }, (_, level) => {
                    const radius = (400 / getMax()) * (level + 1);
                    return (
                        <polygon
                            key={level}
                            points={Array.from({ length: numberOfAbilityPoints }, (_, i) => {
                                const angle = (2 * Math.PI * i) / numberOfAbilityPoints;
                                const x = 500 + radius * Math.cos(angle);
                                const y = 500 + radius * Math.sin(angle);
                                return `${x},${y}`;
                            }).join(" ")}
                            fill="#1F4CC810"
                            stroke="#1F4CC8"
                            strokeWidth="0.5"
                        />
                    );
                })}
                {data.map(({ label }, i) => {
                    const angle = (2 * Math.PI * i) / numberOfAbilityPoints;
                    const x = 500 + 420 * Math.cos(angle); // Slightly outside the polygon
                    const y = 500 + 420 * Math.sin(angle);
                    return (
                        <text
                            key={i}
                            x={x}
                            y={y}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fontSize="32"
                            fontWeight={700}
                            fill="#000"
                        >
                            {label}
                        </text>
                    );
                })}

                <polygon
                    points={
                        Array.from({ length: numberOfAbilityPoints }, (_, i) => {
                            const angle = (2 * Math.PI * i) / numberOfAbilityPoints;
                            const x = 500 + data[i]?.count/data[i]?.total*400 * Math.cos(angle);
                            const y = 500 + data[i]?.count/data[i]?.total*400 * Math.sin(angle);
                            return `${x},${y}`;
                        }).join(" ")
                    }
                    fill="#00E9BA60"
                    stroke="#00BA95"
                    strokeWidth="5"
                />

            </svg>

        </div>
    )
}